import { Font14 } from 'components/Typography'
import styled from 'styled-components'
import theme from 'theme_'

export const PurchaseStateCardSubtitleWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  width: 100%;
  margin-left: 21px;
`

export const PurchaseStateCardSubtitle = styled.span`
  ${Font14}
  text-align: left;
  font-weight: 600;
  color: ${theme.colors.moreGrey};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const PurchaseStateCardCountSubtitle = styled.span<{
  isSuccess: boolean
}>`
  font-size: 18px;
  color: ${({ isSuccess }) =>
    isSuccess ? theme.colors.success : theme.colors.error};
  font-weight: bold;
`
